<template>
  <div>
    <section class="main widgets">
      <div class="figuras negro">
        <div class="container recuperacionwidget" >
          <div class="row">
            <div class="col-12" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
            <div class="row">
              <div class="p-5 col-12">
                <div class="row formulario pt-2 pb-2 widgets" v-show="this.paso == 1">
                  <form method="post" @submit="submitFormulario($event)">
                    <label>
                      <input
                        type="email"
                        class="roboto w400"
                        v-model="form.email"
                        maxlength="100"
                        placeholder="Email"
                        required
                      />
                    </label>

                    <div class="d-flex pb-3">
                      <div class></div>
                      <div class>
                        <div class="pt-2">
                          <button type="submit" class="submit btn btnsup4 fC bold ">Recuperar</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div class="pb-4 white text-center">{{this.mensaje}}</div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>




<script>
import AOS from "aos";
import swal from "sweetalert2";

export default {
  name: "AcademiaDigital",
  props: {
    msg: String
  },
  data() {
    return {
      paso: 1,
      mensaje: "",
      form: {
        nombre: "",
        apellidos: "",
        email: "",
        password: "",
        password2: "",
        fecha: "",
        estado: ""
      },
      form2: {
        email: "",
        codigo: ""
      }
    };
  },
  mounted: function() {
    AOS.init();
  },
  components: {},
  methods: {
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        email: this.form.email
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(this.$store.state.baseurl + "recuperacion.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            this.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              this.mensaje = res.msg;

              this.$gtag.event("Solicitud de recuperación de contraseña", {
                event_category: "MDLP"
              });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);

            this.mensaje =
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.";
          }
        );
    },
    submitVerificacion(e) {
      console.log("submit verificacion");
      var vm = this;
      e.preventDefault();

      this.$router.push("/dashboard");
    }
  }
};
</script>

